import devtoolsApi from '#/dev/devtools';
import { useConfig } from '#/hooks/useConfig';
import { defaultConfig } from '#/service/config';
import { useTranslations } from '#/store/translation/translation.store';

export const useMenu = () => {
  const { translatedMenu } = useTranslations();
  const { menu: menuFromConfig } = useConfig();
  // If `translatedMenu` is defined it means that other language was selected and as such it takes precedence.
  // Otherwise default `menu` config is used, which contains a default english translations
  const menu = translatedMenu ?? menuFromConfig ?? defaultConfig.menu;

  if (process.env.goal === 'local') {
    devtoolsApi.setContexts({ menu });
  }

  return menu;
};
